import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Onboarding } from '../../models/onboarding';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'alg-sections-container',
  templateUrl: './alg-sections-container.component.html',
  styleUrls: ['./alg-sections-container.component.scss'],
})
export class AlgSectionsContainerComponent implements OnInit {
  public sidebarMobileToggle = false;
  public isLoading: BehaviorSubject<boolean> = this.api.isLoading;
  public currentStep: string;
  @Input() containerSectionStatus: string;
  @Output() updateCurrentStep: EventEmitter<string> = new EventEmitter();
  public containerStatusValue: string;
  public currentStatusUpdate: string;
  public steps = [
    {
      name: 'user_info',
      title: 'Titolare della fornitura',
      icon: 'person',
      number: 1,
    },
    {
      name: 'contract_info',
      title: 'Dati contrattuali',
      icon: 'document',
      number: 2,
    },
    {
      name: 'supplies',
      title: 'La tua fornitura',
      icon: 'marker',
      number: 3,
    },
    {
      name: 'payment',
      title: 'Pagamento',
      icon: 'wallet',
      number: 4,
    },
    {
      name: 'insurance',
      title: 'Opzioni Aggiuntive',
      icon: '',
      number: 5,
    },
    {
      name: 'summary',
      title: 'Riepilogo',
      icon: 'clip',
      number: 6,
    },
  ];

  constructor(private api: ApiService) {}

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct)
      .subscribe(([currentOnboarding, product]) => {
        if (product && !!product.name && product.family.name === 'Placet') {
          const objIndex = this.steps.findIndex(
            (obj) => obj.name === 'summary'
          );
          this.steps[objIndex].number = 5;
        }
      });
  }

  public toogleSide() {
    this.sidebarMobileToggle = !this.sidebarMobileToggle;
  }
  ngOnChanges() {
    this.containerStatusValue = this.containerSectionStatus;
  }
  checkChangeStep(event) {
    this.currentStatusUpdate = event;
    return this.updateCurrentStep.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-sections-container/alg-sections-container.component.ts